import { Menu } from 'lucide-react'
import type React from 'react'
import { Portal } from '@/components/ui/portal'
import './CollapsibleToolbar.css'

interface CollapsedButtonProps {
	onExpand: () => void
	position?: 'bottom-right' | 'bottom-left' | 'bottom-center'
	icon?: React.ReactNode
	label?: string
}

/**
 * Button shown when toolbar is collapsed
 * Clicking it expands the toolbar
 */
export const CollapsedButton: React.FC<CollapsedButtonProps> = ({
	onExpand,
	position = 'bottom-right',
	icon,
	label,
}) => {
	const positionClasses = {
		'bottom-right': 'fixed right-20 bottom-8',
		'bottom-left': 'fixed left-20 bottom-8',
		'bottom-center': 'fixed left-1/2 bottom-8 -translate-x-1/2',
	}

	return (
		<Portal>
			<button
				type="button"
				onClick={onExpand}
				aria-expanded={false}
				aria-controls="collapsible-toolbar"
				aria-label={label || 'Expand toolbar'}
				className={`${positionClasses[position]} z-[100] flex h-10 w-10 items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg text-gray-700 hover:bg-[#8c52ff]/10 hover:text-[#8c52ff] transition-all floating-bar-button`}
			>
				{icon || <Menu className="w-5 h-5" />}
			</button>
		</Portal>
	)
}
